import { isValidColorHex } from '@trimble/utilities';
import { ViewerPreferenceSettings } from './viewer-preference-types';

/** Falls back to defaults when persisted preferences are corrupted (e.g. hand-edited localStorage). */
export function isValidViewerPreferenceSettings(
  value: ViewerPreferenceSettings
): boolean {
  return (
    typeof value === 'object' &&
    // eslint-disable-next-line sonarjs/different-types-comparison -- validates untrusted stored values that can be null at runtime
    value !== null &&
    isValidColorHex(value.backgroundTopColor) &&
    isValidColorHex(value.backgroundBottomColor) &&
    isValidColorHex(value.textColor) &&
    typeof value.darkModeMaterials === 'boolean' &&
    isValidColorHex(value.clippingHighlightColor)
  );
}
